import { Separator } from '@/components/ui/separator';
import { SidebarNav } from '@/components/ui/sidebar-nav';
import { Outlet } from 'react-router-dom';

export function SettingsLayouts() {
  return (
    <>
      <h1 className="text-3xl font-bold">Settings</h1>
      <Separator className="my-6" />

      <div className="flex flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0 pb-4">
        <aside className="lg:w-1/5">
          <SidebarNav
            items={[
              { href: '/settings/notification', title: 'Notification' },
              { href: '/settings/appearance', title: 'Appearance' },
            ]}
          />
        </aside>
        <div className="flex-1 lg:max-w-2xl">
          <Outlet />
        </div>
      </div>
    </>
  );
}
